import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/components/docs-layout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "frequently-asked-questions"
    }}>{`Frequently Asked Questions`}</h1>
    <h3 {...{
      "id": "will-the-nicenano-work-on-my-keyboard"
    }}>{`Will the nice!nano work on my keyboard?`}</h3>
    <p>{`Almost every Pro Micro based keyboard should work with the nice!nano. If you want to use the nice!nano on an existing keyboard, it will be much more complicated and will require "hijacking" the existing matrix.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The nice!nano will `}<em parentName="p">{`NOT`}</em>{` work with the Gherkin or Helix unless you leave the RAW pin disconnected from the board.`}</p>
    </blockquote>
    <h3 {...{
      "id": "how-is-the-nicenano-poweredhow-do-the-split-boards-power-each-other"
    }}>{`How is the nice!nano powered/how do the split boards power each other?`}</h3>
    <p>{`They are NOT at all designed to power each other, as each has an individual Li-Po battery connected to it via 2 extra pins at the top of the board (called B+ and B-). Using other means (TRRS) to share power is problematic and should be avoided (see below).`}</p>
    <h3 {...{
      "id": "how-do-you-charge-the-nicenano"
    }}>{`How do you charge the nice!nano?`}</h3>
    <p>{`The nice!nano has a Li-Po charger built in that uses the USB-C port to charge the Li-Po at a rate of 100mA.`}</p>
    <h3 {...{
      "id": "how-long-does-the-nicenano-last-on-battery"
    }}>{`How long does the nice!nano last on battery?`}</h3>
    <p>{`This is highly dependent on the battery size and features of the keyboard. The `}<a parentName="p" {...{
        "href": "https://zmk.dev/power-profiler"
      }}>{`power profiler`}</a>{` from ZMK offers a good estimate of the battery life you can expect.`}</p>
    <h3 {...{
      "id": "does-the-nicenano-work-over-usb"
    }}>{`Does the nice!nano work over USB?`}</h3>
    <p>{`Yes!`}</p>
    <h3 {...{
      "id": "do-you-still-need-a-trrs-jack"
    }}>{`Do you still need a TRRS jack?`}</h3>
    <p>{`No, there's a connection via BLE between the two boards. The central half reports back the keystrokes of both the central (usually left) and peripheral (usually right) sides. Infact using a TRRS jack with the batteries still connected is strongly discouraged, as this (because of the inherent design of the TRRS) can cause a short ciruit
and damage the IO pins on the nice!nano.`}</p>
    <h3 {...{
      "id": "qmk-firmware-support"
    }}>{`QMK firmware support?`}</h3>
    <p>{`This is complicated. Nordic's nRF52 line has some licensing issues with its SDK making it not possible to be upstreamed to the main QMK repo. Instead, we rely on other firmwares like `}<a parentName="p" {...{
        "href": "/docs/wireless-firmware/"
      }}>{`ZMK or BlueMicro`}</a>{` that offer a great deal of functionality with full legality and wireless focus.`}</p>
    <h3 {...{
      "id": "can-i-get-more-information-on-nrf52840-hardware"
    }}>{`Can I get more information on nRF52840 hardware?`}</h3>
    <p>{`Joric's nRFmicro wiki is an amazing resource to get some basic and advanced information on the nRF52 line in terms of keyboards: `}<a parentName="p" {...{
        "href": "https://github.com/joric/nrfmicro/wiki"
      }}>{`https://github.com/joric/nrfmicro/wiki`}</a></p>
    <h3 {...{
      "id": "how-is-this-different-from-the-nrfmicro-or-bluemicro"
    }}>{`How is this different from the nRFMicro or BlueMicro?`}</h3>
    <p>{`The nRFmicro is extremely similar to the nice!nano. The main difference is depending on the version of the nRFMicro, the power system would be slightly different from the nice!nano. From a usability standpoint, very little is different. The nice!nano exposes more pins and is thinner than older versions of the nRFMicro. The biggest difference is that the nice!nano is prebuilt and has a large user base, which therefore has a bigger support community. The BlueMicro is basically the same story except for the nRF52832 versions don't support USB.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      